export default __webpack_public_path__ + "static/media/ic_arrow_long_white.6902532f.svg";